@if (showCertificate) {
  <div class="iframecontainer"  style="outline:none;background:rgba(255,255,255,0.5)">
    @if (isLoading) {
      <div style="position:absolute;width:60px;height:60px;top:calc(50% - 40px);left:calc(50% - 40px)">
        <img src="assets/img/loading.gif">
      </div>
    }
    <div class="closeiframe" (click)="hideStream()">&#10006;</div>
    @if (!isLoading) {
      <object class="streamer" id="iframeobject" [data]="base64Certificate"></object>
    }
  </div>
}
